module.exports = __webpack_public_path__ + "img/loading.2d9ae96d.gif";